import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from '../../../legacy/hui/src/styled/theme';
import { Theme as ThemeBunnings } from '../Bunnings/Theme';
import TickBox from './TickBox';
import { requiredTrue, requiredTrueForQuestion656 } from '../../utils/validation';

//todo make this component/deduplicate??
export const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const AnswerLabel = styled.label`
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid ${colors.GREY};
  border-radius: 100px;
  background-color: ${Theme.snow};
  color: ${colors.MEDIUM_DARK_GREY};
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
`;

const Checkbox = styled(Field)`
  display: none;
`;

const CheckboxOption = styled.div`
  display: inline-block;
  margin: 0 5px 5px 0;

  input[type='checkbox']:checked + label {
    background: ${ThemeBunnings.primary};
    color: ${Theme.snow};
    border-color: ${ThemeBunnings.primary};
  }
`;

export default function CheckboxGroup({ options, name, label, isRequired, id }) {
  if (options.length === 1) {
    const { value } = options[0];
    const key = `${name}.${value}`;
    const getTickBoxValidationRule = (isRequired, questionId) => {
      if (!isRequired) {
        return [];
      }

      switch (questionId) {
        case 656:
          return [requiredTrueForQuestion656];
        default:
          return [requiredTrue];
      }
    };
    return <TickBox name={key} label={label} validate={getTickBoxValidationRule(isRequired, id)} />;
  }
  return (
    <div>
      <QuestionLabel>{label}</QuestionLabel>

      {options.map(({ value, label }) => {
        const key = `${name}.${value}`;
        return (
          <CheckboxOption key={key}>
            <Checkbox
              type="checkbox"
              name={key}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return <input name={key} {...input} {...rest} />;
              }}
            />
            <AnswerLabel key={key} htmlFor={key}>
              {label}
            </AnswerLabel>
          </CheckboxOption>
        );
      })}
    </div>
  );
}

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  isRequired: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.number,
  label: PropTypes.string
};
